<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Geräte</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-data-table style="width: 70vw;"
                  :headers="headers"
                  :items="devices.items.items"
                  :rows-per-page-items="[5,10,20,50,100]"
                  :loading="isLoading"
                  :total-items="totalItems"
                  :must-sort="true"
                  :pagination.sync="pagination"
                  class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.devicename }}</td>
        <td class="text-xs-left">{{ props.item.version }}</td>
        <td class="text-xs-left">{{ props.item.created_at | formatDate }}</td>
        <td class="text-xs-left">{{ props.item.updated_at | formatDate }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'devices',
  data() {
    return {
      totalItems: 0,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'devicename'
      },
      headers: [
        {
          text: 'Gerätename',
          align: 'left',
          sortable: true,
          value: 'devicename'
        },
        {
          text: 'Version',
          align: 'left',
          sortable: true,
          value: 'version'
        },
        {
          text: 'Angelegt',
          align: 'left',
          sortable: false,
          value: 'created_at'
        },
        {
          text: 'Aktualisiert',
          align: 'left',
          sortable: true,
          value: 'updated_at'
        }
      ]
    };
  },
  watch: {
    pagination(newValue, oldValue) {
      this.getDataFromApi();
    },
    devices(newValue, oldValue) {
      console.log(newValue.items.total);
      this.totalItems = newValue.items.total;
    }
  },
  mounted() {
    this.getDataFromApi();
  },
  computed: {
    devices() {
      return this.$store.state.devices.all;
    },
    isLoading() {
      return this.$store.state.devices.loading;
    }
  },
  methods: {
    getDataFromApi() {
      const perpage = this.pagination.rowsPerPage;
      const page = this.pagination.page;
      const sortby = this.pagination.sortBy;
      const descending = this.pagination.descending;

      this.$store.dispatch('devices/getAll', {
        perpage,
        page,
        sortby,
        descending
      });
    }
  }
};
</script>
